import { api } from '@/lib/api'

/**
 * @param {{ user_id?: number, action?: string, date_from?: string, date_to?: string, page?: number, per_page?: number }} [params]
 * @returns {Promise<{ logs: import('@/types/api').AuditLogEntry[], meta: import('@/types/api').PaginationMeta }>}
 */
export async function fetchAuditLogs(params = {}) {
  const { data } = await api.get('/admin/audit-logs', { params })
  return {
    logs: data.data.logs,
    meta: data.data.meta,
  }
}

/**
 * @returns {Promise<Array<{ id: number, name: string }>>}
 */
export async function fetchAuditLogUsers() {
  const { data } = await api.get('/admin/audit-logs/users')
  return data.data.users
}

/**
 * @returns {Promise<string[]>}
 */
export async function fetchAuditActions() {
  const { data } = await api.get('/admin/audit-logs/actions')
  return data.data.actions
}

/**
 * @param {{ user_id?: number, action?: string, date_from?: string, date_to?: string, format?: 'csv' }} [params]
 */
export async function exportAuditLogs(params = {}) {
  const response = await api.get('/admin/audit-logs/export', {
    params: { format: 'csv', ...params },
    responseType: 'blob',
  })

  const disposition = response.headers['content-disposition'] ?? ''
  const match = disposition.match(/filename="?([^";]+)"?/)
  const filename = match?.[1] ?? 'audit-log.csv'

  const url = URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
